var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicAbstractBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 370,
    viewBox: "0 0 421 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M489.567 500.739L489.575 500.731L489.582 500.723C520.453 464.238 537.304 422.219 534.4 368.986C534.398 315.802 520.371 270.878 486.775 234.469C455.981 198.063 413.845 178.4 366.2 178.4C318.54 178.4 279.212 198.075 245.633 234.461L245.625 234.469L245.618 234.478C214.839 270.971 198 315.786 198 369C198 419.419 214.843 464.342 248.433 500.739C282.012 537.125 321.34 556.8 369 556.8C416.66 556.8 455.988 537.125 489.567 500.739ZM369 0.5C475.082 0.5 561.65 33.957 631.446 103.754C701.238 173.546 734.703 262.815 740.3 369.014C740.297 475.089 706.84 561.653 637.046 631.446C567.246 701.247 477.875 737.5 371.8 737.5C265.625 737.5 176.354 701.247 106.554 631.446C36.7501 561.643 0.5 475.171 0.5 369C0.5 262.814 33.9595 173.548 103.754 103.754C173.548 33.9596 262.914 0.5 369 0.5Z",
    stroke: "#CBBFE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicAbstractBackground);
export default __webpack_public_path__ + "static/media/basic-abstract-background.cb08f9815a4ef3cbe81a408eb3aa3a48.svg";
export { ForwardRef as ReactComponent };